export enum DropdownStatus {
  PENDING = 'pending',
  LOADING = 'loading',
  FINISHED = 'finished',
  ERROR = 'error',
}
